document.addEventListener('DOMContentLoaded', function(){
  const cards = $('.ns-introduction-with-cards__card');

  Array(cards).forEach(card => card.viewportChecker({
    classToAdd: 'ns-introduction-with-cards__card_active',
    offset: 100,
    repeat: true,
  }));
});